module.exports = __webpack_public_path__ + "static/media/GY.25efd35a.svg";